import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-50 px-6 py-3 bg-white text-dark lg:px-24 shadow-md" }
const _hoisted_2 = { class: "flex items-center h-20 justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex flex-col justify-center text-end border-r border-primary pr-2 sm:pr-3 mr-2 sm:mr-3" }
const _hoisted_5 = { class: "text-[10px] xs:text-xs uppercase tracking-wider font-semibold text-primary" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "mr-4 lg:hidden" }
const _hoisted_8 = { class: "lg:hidden" }
const _hoisted_9 = { class: "hidden lg:flex lg:items-center" }
const _hoisted_10 = { class: "flex items-center lg:gap-8 lg:text-md mr-6" }
const _hoisted_11 = ["onMouseenter", "onMouseleave"]
const _hoisted_12 = {
  key: 0,
  type: "button",
  class: "flex items-center gap-1.5 font-semibold whitespace-nowrap"
}
const _hoisted_13 = { class: "shiny-text" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "ml-1 inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-primary text-white animate-pulse"
}
const _hoisted_16 = { class: "bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = {
  key: 0,
  class: "ml-2 inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-primary text-white"
}
const _hoisted_20 = {
  key: 0,
  class: "mt-4 lg:hidden overflow-hidden"
}
const _hoisted_21 = {
  key: 0,
  class: "py-1"
}
const _hoisted_22 = { class: "flex items-center gap-1.5" }
const _hoisted_23 = { class: "shiny-text" }
const _hoisted_24 = {
  key: 0,
  class: "pl-4 mt-1 mb-2 space-y-1 border-l-2 border-secondary"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "ml-2 inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-primary text-white"
}
const _hoisted_27 = {
  key: 1,
  class: "block py-1"
}
const _hoisted_28 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_Sparkles = _resolveComponent("Sparkles")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('navbar.by')), 1),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-[11px] xs:text-xs sm:text-sm font-medium" }, "Hnoud Production", -1))
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              src: "/logo.png",
              alt: "Logo",
              class: "w-24 sm:w-24 md:w-24 h-full"
            }, null, -1))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_LanguageSwitcher)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
            class: "text-dark focus:outline-none"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("svg", {
              class: "w-6 h-6",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16m-7 6h7"
              })
            ], -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createElementBlock("div", {
              key: link.key,
              class: _normalizeClass(["relative px-2 py-1 rounded transition-colors duration-100 group", link.isDropdown || link.isNew ? '' : 'hover:bg-primary']),
              onMouseenter: ($event: any) => (link.isDropdown && (_ctx.isDropdownOpen = true)),
              onMouseleave: ($event: any) => (link.isDropdown && _ctx.scheduleHideDropdown())
            }, [
              (link.isDropdown)
                ? (_openBlock(), _createElementBlock("button", _hoisted_12, [
                    _createVNode(_component_Sparkles, { class: "w-4 h-4 text-secondary shrink-0 talent-sparkle" }),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(link.translationKey)), 1),
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["w-3.5 h-3.5 text-primary transition-transform duration-200", { 'rotate-180': _ctx.isDropdownOpen }]),
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, _cache[7] || (_cache[7] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 9l-7 7-7-7"
                      }, null, -1)
                    ]), 2))
                  ]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: link.link,
                    class: _normalizeClass(["block w-full h-full whitespace-nowrap", link.isNew ? 'flex items-center gap-1.5 font-semibold' : 'group-hover:text-white'])
                  }, [
                    (link.isNew)
                      ? (_openBlock(), _createBlock(_component_Sparkles, {
                          key: 0,
                          class: "w-4 h-4 text-secondary shrink-0 talent-sparkle"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(link.isNew ? 'shiny-text' : '')
                    }, _toDisplayString(_ctx.$t(link.translationKey)), 3),
                    (link.isNew)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('navbar.new')), 1))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_14)),
              (link.isDropdown)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["absolute left-1/2 -translate-x-1/2 top-full pt-3 w-64 z-10 transition-all duration-200 ease-out origin-top", { 'opacity-0 invisible scale-95 pointer-events-none': !_ctx.isDropdownOpen, 'opacity-100 visible scale-100': _ctx.isDropdownOpen }]),
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDropdownOpen = true)),
                    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scheduleHideDropdown && _ctx.scheduleHideDropdown(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programsSubmenu, (item) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: item.key,
                          href: item.link,
                          class: "flex items-center justify-between px-4 py-3 text-sm text-dark hover:bg-primary hover:text-white transition-colors duration-150"
                        }, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(item.translationKey)), 1),
                          (item.isNew)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('navbar.new')), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_17))
                      }), 128))
                    ])
                  ], 34))
                : _createCommentVNode("", true)
            ], 42, _hoisted_11))
          }), 128))
        ]),
        _createVNode(_component_LanguageSwitcher)
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "enter-from-class": "opacity-0 max-h-0",
      "enter-to-class": "opacity-100 max-h-[600px]",
      "leave-active-class": "transition-all duration-300 ease-in",
      "leave-from-class": "opacity-100 max-h-[600px]",
      "leave-to-class": "opacity-0 max-h-0"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: link.key
                }, [
                  (link.isDropdown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMobileProgramsOpen = !_ctx.isMobileProgramsOpen)),
                          class: "w-full px-2 py-2 text-left rounded flex justify-between items-center font-semibold"
                        }, [
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_Sparkles, { class: "w-4 h-4 text-secondary shrink-0 talent-sparkle" }),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(link.translationKey)), 1)
                          ]),
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["w-4 h-4 transition-transform duration-200", { 'rotate-180': _ctx.isMobileProgramsOpen }]),
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 9l-7 7-7-7"
                            }, null, -1)
                          ]), 2))
                        ]),
                        (_ctx.isMobileProgramsOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programsSubmenu, (item) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  key: item.key,
                                  href: item.link,
                                  class: "flex items-center justify-between px-3 py-2 text-sm rounded hover:bg-primary hover:text-white"
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.translationKey)), 1),
                                  (item.isNew)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('navbar.new')), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_25))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("a", {
                          href: link.link,
                          class: "block px-2 py-2 rounded hover:bg-primary hover:text-white transition-colors duration-100"
                        }, _toDisplayString(_ctx.$t(link.translationKey)), 9, _hoisted_28)
                      ]))
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}